import type { MouseEvent } from "react";
import { getCourseContent } from "./courseContent";

export function lectureAnchor(title: string): string {
  return `lecture-${title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")}`;
}

export function lectureAt(lectureNumber: number) {
  const row = getCourseContent().lecturesTable.rows[lectureNumber - 1];
  if (!row) {
    return { id: "lectures", title: `Lecture ${lectureNumber}` };
  }
  const title = row.cellNames[1];
  return { id: lectureAnchor(title), title };
}

let jumpToken = 0;
let flashTimer: number | undefined;

function flashLecture(el: HTMLElement) {
  document.querySelectorAll(".is-jump-flash").forEach((node) => {
    node.classList.remove("is-jump-flash");
  });
  void el.offsetWidth;
  el.classList.add("is-jump-flash");
  window.clearTimeout(flashTimer);
  flashTimer = window.setTimeout(() => {
    el.classList.remove("is-jump-flash");
  }, 1200);
}

function whenScrollSettles(onSettle: () => void) {
  const token = ++jumpToken;
  let lastY = window.scrollY;
  let stillFrames = 0;
  let done = false;

  const finish = () => {
    if (done || token !== jumpToken) {
      return;
    }
    done = true;
    onSettle();
  };

  const tick = () => {
    if (done || token !== jumpToken) {
      return;
    }
    if (window.scrollY === lastY) {
      stillFrames += 1;
      if (stillFrames >= 5) {
        finish();
        return;
      }
    } else {
      stillFrames = 0;
      lastY = window.scrollY;
    }
    requestAnimationFrame(tick);
  };

  requestAnimationFrame(tick);
  window.setTimeout(finish, 1600);
}

export function scrollToAnchor(id: string) {
  const el = document.getElementById(id);
  if (!el) {
    return;
  }

  el.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
  window.history.replaceState(null, "", `#${id}`);

  if (!el.classList.contains("card-row")) {
    return;
  }

  whenScrollSettles(() => flashLecture(el));
}

export function handleAnchorClick(
  event: MouseEvent<HTMLAnchorElement>,
  id: string
) {
  event.preventDefault();
  event.stopPropagation();
  scrollToAnchor(id);
}
